// extracted by mini-css-extract-plugin
module.exports = {"dropDown":"AdminReassignModal_dropDown__15kEM"};